function initVerificationForm() {
  const form = document.querySelector('.js-c-user-account-settings--form')
  if (!form) return

  const verificationMethodInputs = form.querySelectorAll('.js-verification-method input')
  const numberInput = form.querySelector('.js-verification-number input')

  if (!verificationMethodInputs.length || !numberInput) return

  function clearNumberIfEmailSelected() {
    const selected = form.querySelector('.js-verification-method input:checked')
    if (selected && selected.value === 'false') {
      numberInput.value = ''
    }
  }

  function handleVerificationMethodChange(event) {
    if (event.target.value === 'false') {
      numberInput.value = ''
    }
  }

  clearNumberIfEmailSelected()

  verificationMethodInputs.forEach(input => {
    input.addEventListener('change', handleVerificationMethodChange)
  })
}

if (document.querySelector('.js-c-user-account-settings--form')) {
  initVerificationForm()
}
